// Type declarations and Defined Ordered Lists
// Types can be dynamically set from string array
// The same string array is used to define the sort order of our types via Utitlies.sortByDefinedOrder() function
// example: array of disseminationOptions['LES', 'REL TO', 'FISA'] will be sorted as ['REL TO', 'FISA', 'LES']

// Below instantiations are Equivilant to:
// export type classificationTypes = ('UNCLASSIFIED' | 'CONFIDENTIAL' | 'SECRET' | 'TOP SECRET');
// export type sciOptionTypes = ('NONE'| 'SI'| 'TK')[] //Array Type
export const classificationOptionsOrder = ['UNCLASSIFIED', 'CONFIDENTIAL', 'SECRET', 'TOP SECRET'] as const;
export type classificationTypes = typeof classificationOptionsOrder[number];

// dissemination*Classification*Options requires 'RELTO' to have no space for proper display in the Select Box
export const disseminationUnclassifiedOptions: string[] = ['NONE', 'FOUO', 'FISA', 'LIMDIS', 'LES'];
export const disseminationConfidentialOptions: string[] = ['NONE', 'ORCON', 'ORCON-USGOV', 'NOFORN', 'REL TO', 'FISA', 'LES'];
export const disseminationSecretOptions: string[] = ['NONE', 'RSEN', 'ORCON', 'ORCON-USGOV', 'IMCON', 'NOFORN', 'REL TO', 'FISA', 'LES'];
export const disseminationTopSecretOptions: string[] = ['NONE', 'RSEN', 'ORCON', 'ORCON-USGOV', 'IMCON', 'NOFORN', 'REL TO', 'FISA', 'LES'];

// Dissemination Control order is specific specified in DoDM 5200.01-v2, February 24, 2012
// Change 3, 05/14/2019 Enclosure 4, 1b, (4)(a) Multiple entries may be chosen from the dissemination
// control categories if applicable. If multiple entries are used, they are listed in the order which
// they appear in Fig 25. items in () aren't in the Figure
//
// 8. Dissemination Controls
// FOR OFFICICIAL USE ONLY (FOUO)
// ORIGINATOR CONTROLLED (ORCON,ORCON-USGOV)
// CONTROLLED IMAGERY (IMCON)
// NOT RELEASABLE TO FOREIGN NATIONALS (NOFORN)
// CAUTION-PROPRIETARY INFORMATION INVOLVED (PROPIN)
// AUTHORIZED FOR RELEASE TO (RELTO)
// RELEASABLE BY INFORMATION DISCLOSURE OFFICIAL (RELIDO)
// FOREIGN INTELLIIGENCE SURVEILLANCE ACT (FISA)
// DISPLAY ONLY
//
// The Intelligence Community Markings System Register and Manual
// Effective: 30 August 2019 it specifies RISK SENSITIVE (RSEN) before FOUO
// in the Dissemination Controls Section. Section 9 Other Dissemination
// Controls specifies that the following controls should be separated from the
// Dissemination Controls section by // and be in the following order:
//
// 9. Other Dissemination Controls
// Limdis, Exclusive Distribution (EXDIS), No Distribution (NODIS), Sensitive
// But Unclassified (SBU), Law Enforcement Sensitive (LES), and SSI
//
// NOTES:
//     * We've been told to use ORCON-USGOV
//     * DISPLAY ONLY requires country support that PCT does not currently have
//     * RELIDO is not supported by FGAC currently
//     * LIMDIS & RSEN only apply to NGA data
//     * RSEN is allows S & TS only

// disseminationOptionsOrder requires 'REL TO' to have a space for proper Banner String Parsing
export const disseminationOptions = ['NONE', 'RSEN', 'FOUO', 'ORCON', 'ORCON-USGOV', 'IMCON', 'NOFORN', 'PROPIN', 'REL TO', 'RELIDO', 'FISA'];

// This variable controls the disseminations that should fall into OTHER DISSEM as specified in
// Figure 25 of DoDM 5200.01-v2, February 24, 2012 or in the Intelligence Community Markings
// System Register and Manual Effective: 30 August 2019 documents. The exception is ACCMs which are
// always added into the OTHER DISSEM category by design.
export const otherDissemOptionsOrder = ['LIMDIS', 'EXDIS', 'NODIS', 'SBU', 'LES', 'SSI', 'CVI'] as const;
export type otherDissemOptionTypes = typeof otherDissemOptionsOrder[number][];

// disseminationOptions needs to combined with otherDissemOptions for proper sorting of Dissemination Options
export const disseminationOptionsOrder = [...disseminationOptions, ...otherDissemOptionsOrder] as const;
export type disseminationOptionTypes = typeof disseminationOptionsOrder[number][];

export const relToOptionsOrder = ['USA', 'FVEY', 'AUS', 'CAN', 'GBR', 'NZL', 'ACGU', 'NATO', 'ABW', 'AFG', 'AGO', 'AIA', 'ALB', 'AMSP', 'AND', 'ANT',
    'APFS', 'ARE', 'ARG', 'ARM', 'ASM', 'ATA', 'ATF', 'ATG', 'AUT', 'AZE', 'BDI', 'BEL', 'BEN', 'BFA', 'BGD', 'BGR', 'BHR', 'BHS', 'BIH',
    'BLM', 'BLR', 'BLZ', 'BMU', 'BOL', 'BRA', 'BRB', 'BRN', 'BTN', 'BVT', 'BWA', 'BWCS', 'CAF', 'CCK', 'CFCK', 'CHE', 'CHL', 'CHN', 'CIV',
    'CMFC', 'CMFP', 'CMR', 'COD', 'COG', 'COK', 'COL', 'COM', 'CPMT', 'CPV', 'CRI', 'CUB', 'CWCS', 'CXR', 'CYM', 'CYP', 'CZE', 'DEU', 'DJI',
    'DMA', 'DNK', 'DOM', 'DZA', 'ECTF', 'ECU', 'EFOR', 'EGY', 'ERI', 'ESH', 'ESP', 'EST', 'ETH', 'FIN', 'FJI', 'FLK', 'FRA', 'FRME', 'FRO', 'FSM',
    'FXX', 'GAB', 'GCTF', 'GEO', 'GGY', 'GHA', 'GIB', 'GIN', 'GLP', 'GMB', 'GMIF', 'GNB', 'GNQ', 'GRC', 'GRD', 'GRL', 'GTM', 'GUF', 'GUM',
    'GUY', 'HKG', 'HMD', 'HND', 'HRV', 'HTI', 'HUN', 'IDN', 'IESC', 'IMN', 'IND', 'IOT', 'IRKS', 'IRL', 'IRN', 'IRQ', 'ISL', 'ISR', 'ITA', 'JAM',
    'JEY', 'JOR', 'JPN', 'KAZ', 'KEN', 'KFOR', 'KGZ', 'KHM', 'KIR', 'KNA', 'KOR', 'KWT', 'LAO', 'LBN', 'LBR', 'LBY', 'LCA', 'LIE', 'LKA',
    'LSO', 'LTU', 'LUX', 'LVA', 'MAC', 'MAF', 'MAR', 'MCFI', 'MCO', 'MDA', 'MDG', 'MDV', 'MESF', 'MEX', 'MHL', 'MIFH', 'MKD', 'MLI', 'MLT', 'MMR',
    'MNE', 'MNG', 'MNP', 'MOZ', 'MRT', 'MSR', 'MTQ', 'MUS', 'MWI', 'MYS', 'MYT', 'NACT', 'NAM', 'NCL', 'NER', 'NFK', 'NGA', 'NIC', 'NIU',
    'NLD', 'NOR', 'NPL', 'NRU', 'OMN', 'OSAG', 'PAK', 'PAN', 'PCN', 'PER', 'PHL', 'PLW', 'PNG', 'POL', 'PRI', 'PRK', 'PRT', 'PRY', 'PSE', "PSMX",
    'PYF', 'QAT', 'REU', 'ROU', 'RSMA', 'RUS', 'RWA', 'SAU', 'SDN', 'SEN', 'SGP', 'SGS', 'SHN', 'SJM', 'SLB', 'SLE', 'SLV', 'SMR', 'SOM',
    'SPM', 'SRB', 'STP', 'SUR', 'SVK', 'SVN', 'SWE', 'SWZ', 'SYC', 'SYR', 'TCA', 'TCD', 'TGO', 'THA', 'TJK', 'TKL', 'TKM', 'TLS', 'TON',
    'TUN', 'TUR', 'TUV', 'TWN', 'TZA', 'UGA', 'UKR', 'UMI', 'UNCK', 'URY', 'UZB', 'VAT', 'VCT', 'VEN', 'VGB', 'VIR', 'VNM', 'VUT', 'WLF',
    'WSM', 'YEM', 'ZAF', 'ZMB', 'ZWE'] as const;
export type relToOptionTypes = typeof relToOptionsOrder[number][];

export const sciConfidentialOptions: string[] = ['NONE', 'SI'];
export const sciSecretOptions: string[] = ['NONE', 'SI', 'TK'];
export const sciTopSecretOptions: string[] = ['NONE', 'SI', 'TK'];
// SCI Control order is specific specified in DoDM 5200.01-v2, February 24, 2012
// Change 3, 05/14/2019 Enclosure 4, 6c Multiple SCI control system entries may be used if applicable.
// When multiple entries, (whether published or unpublished) are used, list them alphabetically. Use
// a single forward slash (/) as the separator between multiple SCI control system entries (see Figure 33).
//
// Notes:
//     * -G only allowed at TS and requires ORCON and not ORCON-USGOV
//     * All compartments need their own entry e.g. SI-G, SI-XXX, these will be properly combined for
//       the classification banner e.g. SI-G-XXX
//     * Subcompartments are untested
export const sciOptionsOrder = ['NONE', 'HCS', 'HCS-O', 'HCS-P', 'KLM-R', 'SI', 'SI-G', 'TK', 'TK-GEOCAP'] as const;
export type sciOptionTypes = typeof sciOptionsOrder[number][];

export const fgiOptionsOrder = ['CONCEALED', 'AUS', 'CAN', 'GBR', 'NZL', 'ABW', 'ACGU', 'AFG', 'AGO', 'AIA', 'ALB', 'AND', 'ANT', 'APFS', 'ARE',
    'ARG', 'ARM', 'ASM', 'ATA', 'ATF', 'ATG', 'AUT', 'AZE', 'BDI', 'BEL', 'BEN', 'BFA', 'BGD', 'BGR', 'BHR', 'BHS', 'BIH', 'BLM', 'BLR',
    'BLZ', 'BMU', 'BOL', 'BRA', 'BRB', 'BRN', 'BTN', 'BVT', 'BWA', 'BWCS', 'CAF', 'CCK', 'CFCK', 'CHE', 'CHL', 'CHN', 'CIV', 'CMFC', 'CMFP',
    'CMR', 'COD', 'COG', 'COK', 'COL', 'COM', 'CPMT', 'CPV', 'CRI', 'CUB', 'CWCS', 'CXR', 'CYM', 'CYP', 'CZE', 'DEU', 'DJI', 'DMA', 'DNK',
    'DOM', 'DZA', 'ECTF', 'ECU', 'EFOR', 'EGY', 'ERI', 'ESH', 'ESP', 'EST', 'ETH', 'FIN', 'FJI', 'FLK', 'FRA', 'FRO', 'FSM', 'FVEY', 'FXX',
    'GAB', 'GCTF', 'GEO', 'GGY', 'GHA', 'GIB', 'GIN', 'GLP', 'GMB', 'GMIF', 'GNB', 'GNQ', 'GRC', 'GRD', 'GRL', 'GTM', 'GUF', 'GUM', 'GUY',
    'HKG', 'HMD', 'HND', 'HRV', 'HTI', 'HUN', 'IDN', 'IESC', 'IMN', 'IND', 'IOT', 'IRL', 'IRN', 'IRQ', 'ISL', 'ISR', 'ITA', 'JAM', 'JEY',
    'JOR', 'JPN', 'KAZ', 'KEN', 'KFOR', 'KGZ', 'KHM', 'KIR', 'KNA', 'KOR', 'KWT', 'LAO', 'LBN', 'LBR', 'LBY', 'LCA', 'LIE', 'LKA', 'LSO',
    'LTU', 'LUX', 'LVA', 'MAC', 'MAF', 'MAR', 'MCFI', 'MCO', 'MDA', 'MDG', 'MDV', 'MEX', 'MHL', 'MIFH', 'MKD', 'MLI', 'MLT', 'MMR', 'MNE',
    'MNG', 'MNP', 'MOZ', 'MRT', 'MSR', 'MTQ', 'MUS', 'MWI', 'MYS', 'MYT', 'NACT', 'NAM', 'NATO', 'NCL', 'NER', 'NFK', 'NGA', 'NIC', 'NIU',
    'NLD', 'NOR', 'NPL', 'NRU', 'OMN', 'OSAG', 'PAK', 'PAN', 'PCN', 'PER', 'PHL', 'PLW', 'PNG', 'POL', 'PRI', 'PRK', 'PRT', 'PRY', 'PSE',
    'PYF', 'QAT', 'REU', 'ROU', 'RSMA', 'RUS', 'RWA', 'SAU', 'SDN', 'SEN', 'SGP', 'SGS', 'SHN', 'SJM', 'SLB', 'SLE', 'SLV', 'SMR', 'SOM',
    'SPM', 'SRB', 'STP', 'SUR', 'SVK', 'SVN', 'SWE', 'SWZ', 'SYC', 'SYR', 'TCA', 'TCD', 'TGO', 'THA', 'TJK', 'TKL', 'TKM', 'TLS', 'TON',
    'TUN', 'TUR', 'TUV', 'TWN', 'TZA', 'UGA', 'UKR', 'UMI', 'UNCK', 'URY', 'UZB', 'VAT', 'VCT', 'VEN', 'VGB', 'VIR', 'VNM', 'VUT', 'WLF',
    'WSM', 'YEM', 'ZAF', 'ZMB', 'ZWE'] as const;
export type fgiOptionTypes = typeof fgiOptionsOrder[number][];

export const sigintOptionsOrder = ['Raw', 'Is Evaluated And Minimized', 'Is Disseminable'] as const;
export type sigintOptionTypes = typeof sigintOptionsOrder[number][];

export const acquisitionLacOptions: string[] = ['EO12333_D5240_NONSIGINT_NES', 'EO12333_D5240_PUBLICLY_AVAIL', 'EO12333_S', 'EO12333_S_EXTENDED', 'SIGINT_MSNMGT_GEN', 'TEST_DATA'];
export const disseminableLacOptions: string[] = ['DISSEM_CYBER', 'DISSEM_FI_NONSIGINT', 'DISSEM_FI_SIGINT', 'DISSEM_IA', 'IC_DATA'];
export const lacOptionsOrder = [...acquisitionLacOptions, ...disseminableLacOptions] as const;
export type lacOptionTypes = typeof lacOptionsOrder[number][];

export const topicOptionsOrder = [
    {'name': 'Any', 'value': 'ANY'},
    {'name': 'Crime and Narcotics', 'value': 'CN'},
    {'name': 'Cyber, Science, and Technology', 'value': 'CST'},
    {'name': 'Defense Issues', 'value': 'DI'},
    {'name': 'Economics, Trade, and Threat Finance', 'value': 'ET'},
    {'name': 'Environment and Infrastructure', 'value': 'EI'},
    {'name': 'Health and Natural Disasters', 'value': 'HND'},
    {'name': 'Intelligence and Counterintelligence', 'value': 'IC'},
    {'name': 'Political and Societal Issues', 'value': 'PSI'},
    {'name': 'Terrorism and Homeland Security', 'value': 'THS'},
    {'name': 'Weapons and Proliferation and WMD', 'value': 'WPW'},
] as const;
export type topicOptionTypes = typeof topicOptionsOrder[number][];
// Topic Options Values Only
export const topicOptionsValuesOrder = topicOptionsOrder.map((topic) => topic.value);
export type topicOptionValueTypes = typeof topicOptionsValuesOrder[number][];

export const regionOptionsOrder = [
    {'value': 'ANAN', 'name': 'Any'},
    {'value': 'AFce', 'name': 'Africa, Central'},
    {'value': 'AFea', 'name': 'Africa, East'},
    {'value': 'AFno', 'name': 'Africa, North'},
    {'value': 'AFso', 'name': 'Africa, Southern'},
    {'value': 'AFwe', 'name': 'Africa, West'},
    {'value': 'AMca', 'name': 'Americas, Caribbean'},
    {'value': 'AMce', 'name': 'Americas, Central'},
    {'value': 'AMno', 'name': 'Americas, North'},
    {'value': 'AMso', 'name': 'Americas, South'},
    {'value': 'AMan', 'name': 'Americas, Antarctica'},
    {'value': 'ASea', 'name': 'Asia, East'},
    {'value': 'ASse', 'name': 'Asia, South East'},
    {'value': 'ASso', 'name': 'Asia, South'},
    {'value': 'EAca', 'name': 'Eurasia, Caucasus'},
    {'value': 'EAce', 'name': 'Eurasia, Central'},
    {'value': 'EAru', 'name': 'Eurasia, Russia'},
    {'value': 'EUba', 'name': 'Europe, Balkans'},
    {'value': 'EUce', 'name': 'Europe, Central'},
    {'value': 'EUno', 'name': 'Europe, North'},
    {'value': 'EUso', 'name': 'Europe, South'},
    {'value': 'MEme', 'name': 'Middle East'},
    {'value': 'OCoc', 'name': 'Oceania'},
] as const;
export type regionOptionTypes = typeof regionOptionsOrder[number][];
// Region Options Values Only
export const regionOptionsValuesOrder = regionOptionsOrder.map((region) => region.value);
export type regionOptionValueTypes = typeof regionOptionsValuesOrder[number][];
